export default __webpack_public_path__ + "static/media/gmail.f6e68975.gif";